import React from "react";

// Building up options elements from the JSON data in the arrays defined below
// so we can just import the options elements in the form where we need them

const sportTypes = [
  {
    displayName: "N/A"
  },
  {
    displayName: "Baseball",
    trelloLabelId: "571fd059b0dfecc6d10f4c5d"
  },
  {
    displayName: "Men's Basketball",
    trelloLabelId: "571fd059b0dfecc6d10f4c5a"
  },
  {
    displayName: "Women's Basketball",
    trelloLabelId: "571fd6e5b0dfecc6d10f63d7"
  },
  {
    displayName: "Football",
    trelloLabelId: "571fd6b7b0dfecc6d10f634f"
  },
  {
    displayName: "Men's Golf",
    trelloLabelId: "571ff081bc1a2b75d4ab8b50"
  },
  {
    displayName: "Women's Golf",
    trelloLabelId: "571ff09065f52e2d974dc73c"
  },
  {
    displayName: "Rowing",
    trelloLabelId: "571ff0dcb0dfecc6d10fae71"
  },
  {
    displayName: "Soccer",
    trelloLabelId: "571ff0b04c71ea0a9cbd6d93"
  },
  {
    displayName: "Softball",
    trelloLabelId: "571fed76b0dfecc6d10fa6b8"
  },
  {
    displayName: "Swimming & Diving",
    trelloLabelId: "571ff119b0dfecc6d10faeda"
  },
  {
    displayName: "Men's Tennis",
    trelloLabelId: "571ff147f5976b221c9b8c17"
  },
  {
    displayName: "Women's Tennis",
    trelloLabelId: "571ff14e9bc818d3cf615357"
  },
  {
    displayName: "Track/XC",
    trelloLabelId: "571ff16a847d873e0a6e5cf9"
  },
  {
    displayName: "Volleyball",
    trelloLabelId: "571ff172196afdf8de060e39"
  }
];

const sportTypeOptions = sportTypes.map((type, index) => (
  <option key={index}>{`${type.displayName}`}</option>
));

export { sportTypeOptions };



// WEBPACK FOOTER //
// ./src/Video/config/formOptionElements.js